export default __webpack_public_path__ + "static/media/Ab4.80a9dfbb.mp3";